import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box, ButtonGroup, Feedback, StackView, Typography } from '@telus-uds/components-web';
import ColorButtonGroup from './ColorButtonGroup';
import CPODetailsPanel from './CPODetailsPanel';
import attributeSelectionReducer from './utils/attributeSelectionReducer';
import getAllPhoneDetails from './utils/getAllPhoneDetails';
import getDefaultPhone from './utils/getDefaultPhone';
import getUniqueDeviceOptions from './utils/getUniqueDeviceOptions';
var renderRadioOptions = function (optionArray, activeElement, handleOptionClick) {
    var getOptionName = function (option) {
        var name = '';
        if (option === null || option === void 0 ? void 0 : option.name) {
            name = 'color';
        }
        else if (option.ref) {
            name = 'storage';
        }
        else {
            name = 'condition';
        }
        return name;
    };
    var radioOptions = optionArray.map(function (option) {
        var _a;
        return {
            label: (option === null || option === void 0 ? void 0 : option.name) ||
                (option === null || option === void 0 ? void 0 : option.ref) ||
                option.condition,
            value: (_a = option.hex) !== null && _a !== void 0 ? _a : option.id,
            id: option.id
        };
    });
    var handleOptionChange = function (optionName, optionIds) {
        if (handleOptionClick) {
            var optionId = optionIds.length > 0 ? optionIds[0] : '';
            var e = { target: { name: optionName, value: optionId } };
            handleOptionClick(e);
        }
    };
    var optionName = optionArray.length > 0 ? getOptionName(optionArray[0]) : '';
    if (optionName === 'color') {
        return (_jsx(ColorButtonGroup, { items: radioOptions, onColorChange: function (optionId) { return handleOptionChange(optionName, [optionId]); }, values: [activeElement] }));
    }
    return (_jsx(ButtonGroup, { tokens: { space: 2 }, items: radioOptions, onChange: function (optionIds) { return handleOptionChange(optionName, optionIds); }, values: [activeElement] }));
};
export var VariantSelector = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.devices, devices = _f === void 0 ? [] : _f, updateActiveSku = _a.updateActiveSku, _g = _a.errorText, errorText = _g === void 0 ? '' : _g, labels = _a.labels, cpoDetails = _a.cpoDetails;
    var deviceData = React.useMemo(function () { return getAllPhoneDetails(devices); }, [devices]);
    var defaultPhone = React.useMemo(function () { return getDefaultPhone(deviceData); }, [deviceData]);
    var initialState = React.useMemo(function () {
        var _a, _b, _c, _d, _e;
        return ({
            deviceData: deviceData,
            color: (_a = defaultPhone === null || defaultPhone === void 0 ? void 0 : defaultPhone.color) === null || _a === void 0 ? void 0 : _a.id,
            storage: (_b = defaultPhone === null || defaultPhone === void 0 ? void 0 : defaultPhone.storage) === null || _b === void 0 ? void 0 : _b.id,
            condition: (_c = defaultPhone === null || defaultPhone === void 0 ? void 0 : defaultPhone.condition) === null || _c === void 0 ? void 0 : _c.id,
            colorNotFound: false,
            deviceOptions: getUniqueDeviceOptions(deviceData, (_d = defaultPhone === null || defaultPhone === void 0 ? void 0 : defaultPhone.condition) === null || _d === void 0 ? void 0 : _d.id, (_e = defaultPhone === null || defaultPhone === void 0 ? void 0 : defaultPhone.storage) === null || _e === void 0 ? void 0 : _e.id)
        });
    }, [defaultPhone, deviceData]);
    var _h = React.useReducer(attributeSelectionReducer, initialState), state = _h[0], dispatch = _h[1];
    var color = state.color, storage = state.storage, condition = state.condition, colorNotFound = state.colorNotFound, deviceOptions = state.deviceOptions;
    var _j = cpoDetails !== null && cpoDetails !== void 0 ? cpoDetails : {}, cpoTitle = _j.title, cpoDescription = _j.description;
    var _k = React.useState(false), isCPO = _k[0], setIsCPO = _k[1];
    var getColorNameById = function (colorId) {
        var _a, _b;
        return (_b = (_a = deviceOptions === null || deviceOptions === void 0 ? void 0 : deviceOptions.colorOptions) === null || _a === void 0 ? void 0 : _a.find(function (co) { return (co === null || co === void 0 ? void 0 : co.id) === colorId; })) === null || _b === void 0 ? void 0 : _b.name;
    };
    React.useEffect(function () {
        // Updates the initial state of the component when parent rerenders.
        dispatch({
            type: 'UPDATE_INITIAL_STATE',
            payload: { initialState: initialState }
        });
    }, [devices]);
    var handleOptionClick = function (e) {
        var _a;
        var _b = e.target, value = _b.value, name = _b.name;
        dispatch({ type: 'SHOW_ERROR', payload: false });
        if (name && value) {
            dispatch({
                type: "UPDATE_".concat(name.toUpperCase()),
                payload: (_a = {}, _a[name] = value, _a)
            });
        }
    };
    React.useEffect(function () {
        // Find the active device based on selected storage, color and condition.
        var activeDevice = deviceData.find(function (device) {
            var _a, _b, _c;
            return ((_a = device === null || device === void 0 ? void 0 : device.color) === null || _a === void 0 ? void 0 : _a.id) === color &&
                ((_b = device === null || device === void 0 ? void 0 : device.storage) === null || _b === void 0 ? void 0 : _b.id) === storage &&
                ((_c = device === null || device === void 0 ? void 0 : device.condition) === null || _c === void 0 ? void 0 : _c.id) === condition;
        });
        // If no device is found using the color find the active device based on selected storage and condition.
        if (!activeDevice) {
            activeDevice = deviceData.find(function (device) { var _a, _b; return ((_a = device === null || device === void 0 ? void 0 : device.condition) === null || _a === void 0 ? void 0 : _a.id) === condition && ((_b = device === null || device === void 0 ? void 0 : device.storage) === null || _b === void 0 ? void 0 : _b.id) === storage; });
        }
        if (activeDevice) {
            if (updateActiveSku) {
                updateActiveSku(activeDevice.sku);
            }
            setIsCPO((activeDevice === null || activeDevice === void 0 ? void 0 : activeDevice.type) === 'preowned');
        }
    }, [condition, color, storage]);
    return (_jsx(Box, { children: _jsxs(StackView, { space: 4, children: [((!isCPO && ((_b = deviceOptions === null || deviceOptions === void 0 ? void 0 : deviceOptions.conditionOptions) === null || _b === void 0 ? void 0 : _b.length) > 1) || isCPO) && (_jsxs(StackView, { space: 2, children: [_jsx(Typography, { variant: { bold: true }, children: (_c = labels === null || labels === void 0 ? void 0 : labels.conditionSelectionLabel) !== null && _c !== void 0 ? _c : '' }), (deviceOptions === null || deviceOptions === void 0 ? void 0 : deviceOptions.conditionOptions) &&
                            renderRadioOptions(deviceOptions.conditionOptions, condition, handleOptionClick), cpoTitle && cpoDescription && (_jsx(CPODetailsPanel, { title: cpoTitle, description: cpoDescription }))] })), _jsxs(StackView, { space: 2, children: [_jsx(Typography, { variant: { bold: true }, children: (_d = labels === null || labels === void 0 ? void 0 : labels.storageSelectionLabel) !== null && _d !== void 0 ? _d : '' }), (deviceOptions === null || deviceOptions === void 0 ? void 0 : deviceOptions.storageOptions) &&
                            renderRadioOptions(deviceOptions.storageOptions, storage, handleOptionClick)] }), _jsxs(StackView, { space: 1, children: [_jsxs(StackView, { direction: 'row', children: [_jsx(Typography, { variant: { bold: true }, children: (_e = labels === null || labels === void 0 ? void 0 : labels.colorSelectionLabel) !== null && _e !== void 0 ? _e : '' }), _jsxs(Typography, { testID: "selected-color", children: [" ", getColorNameById(color)] })] }), (deviceOptions === null || deviceOptions === void 0 ? void 0 : deviceOptions.colorOptions) &&
                            renderRadioOptions(deviceOptions.colorOptions, color, handleOptionClick)] }), colorNotFound && _jsx(Feedback, { validation: "error", children: errorText })] }) }));
};
